import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import IntlMessages from 'util/IntlMessages';
import { useSelector, useDispatch } from 'react-redux';
import {onCloseWarning} from 'actions'
function WarningFileContainMaleware(props) {
    const dispatch = useDispatch()
    const[showAlert,setshowAlert] = React.useState(false)
    console.log(props.OpenSweetAlert)
    React.useEffect(()=>{
      if(showAlert !== props.OpenSweetAlert){
        setshowAlert(props.OpenSweetAlert)
      }
    },[props.OpenSweetAlert])
    return (
        <div>
          <SweetAlert
            danger
          style={{ backgroundColor:'#fbfbfb'}}
          show={showAlert}
          title=""
          timeout={3500}
          showConfirmButton={true}
          confirmBtnCssClass={"d-none"}
          onConfirm={() => {
            setshowAlert(false)
            dispatch(onCloseWarning())
          }}
          >
               {props.scanDocument} <IntlMessages id="Contain.MaleWare"/>
    </SweetAlert>
        </div>
    );
}

export default WarningFileContainMaleware;